import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { FormsModule } from '@angular/forms'

// Import components to be shared
import { EncabezadoModuloComponent } from './componentes/encabezado-modulo/encabezado-modulo.component';
import { MenuModuloComponent } from './componentes/menu-modulo/menu-modulo.component'
import { MapaComponent } from './componentes/mapa/mapa.component';
import { TruncatePipe } from './pipes/truncate.pipe';
import { SafeHtmlPipe } from './pipes/safeHtml.pipe';
import { Ng2SearchPipeModule } from 'ng2-search-filter';
import { SafeResourcePipe } from './pipes/safeResource.pipe';
import { FormularioContactoComponent } from './componentes/formulario-contacto/formulario-contacto.component'

import { AgendaActividadesComponent } from './componentes/agenda/agenda-actividades/agenda-actividades.component';

import { ModalFundamentoComponent } from './componentes/modal-fundamento/modal-fundamento.component'
import { SinContenidoComponent } from './componentes/sin-contenido/sin-contenido.component';
import { BotonRegresarComponent } from './componentes/boton-regresar/boton-regresar.component';
import { NoticiasPortadaComponent } from './componentes/noticias-portada/noticias-portada.component';

@NgModule({
  imports: [CommonModule, RouterModule, Ng2SearchPipeModule, FormsModule],
  declarations: [NoticiasPortadaComponent, BotonRegresarComponent, EncabezadoModuloComponent, MenuModuloComponent, MapaComponent, SinContenidoComponent, TruncatePipe,
    SafeHtmlPipe, SafeResourcePipe, ModalFundamentoComponent, FormularioContactoComponent, AgendaActividadesComponent],
  exports: [NoticiasPortadaComponent, BotonRegresarComponent, EncabezadoModuloComponent, MenuModuloComponent, MapaComponent, SinContenidoComponent, TruncatePipe,
    SafeHtmlPipe, SafeResourcePipe, ModalFundamentoComponent, FormularioContactoComponent, CommonModule, Ng2SearchPipeModule, FormsModule, AgendaActividadesComponent]
})

export class CompartidoModule { }